export const colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#FFFFFF',

  red: {
    500: '#C73030',
    400: '#D25959',
    100: '#FFE3E3',
  },
  petrol: {
    500: '#002E33',
    400: '#004B54',
    100: '#E9F1F1',
  },
  gray: {
    400: '#9D9D9D',
    300: '#E6E6E6',
    250: '#E5E5E5',
    200: '#EFEFEF',
    100: '#F8F8F8',
  },
  yellow: {
    400: '#FFE33D',
  },
  orange: {
    500: '#C99034',
    400: '#DC9D39',
    300: '#F2AE41',
    200: '#F6CE80',
    100: '#FDF5E5',
  },
  green: {
    400: '#50974C',
    300: '#54A34D',
    200: '#6EB56B',
    100: '#ECF6ED',
  },
  blue: {
    400: '#095FBE',
    300: '#4679BD',
  },
};

export const palette = {
  colors: {
    ...colors,
    primary: colors.petrol[400],
    error: colors.red[500],
    focus: 'rgba(9, 95, 190, 0.4)',
  },
  bg: {
    default: colors.white,
    dark: colors.petrol[400],
    modal: 'rgba(46, 46, 46, 0.9)',
  },
};
